import React, {useEffect, useState} from 'react';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {Button, Drawer, message, Table} from 'antd';
import {ButtonProps} from 'antd/lib/button';
import {useInput, useBoolean} from 'react-hanger';
import SearchAndRefresh from '../Shared/SearchAndRefresh';
import CourseArticleKeywordFilter from '../../utils/keywordFiliter/CourseArticle';
import {CourseArticleApi, CourseArticleDto} from '../../scaffold';

export interface ICourseArticleSelectedTableProps {
  value: CourseArticleDto[];
  onChange: (v: CourseArticleDto[]) => any;
}
export interface ICourseArticleSelectedBtnProps extends ButtonProps {
  onConfirm: (CourseArticles: CourseArticleDto[]) => Promise<any>;
}
export function CourseArticleSelectedBtn(props: ICourseArticleSelectedBtnProps) {
  const {...btnProps} = props;
  const [value, setValue] = useState<CourseArticleDto[]>([]);
  const isDialog = useBoolean(false);
  const loading = useBoolean(false);
  async function onSelect() {
    try {
      loading.setTrue();
      await props.onConfirm(value);
      loading.setFalse();
      setValue([]);
      isDialog.setFalse();
    } catch (e) {
      message.error(e.message);
      loading.setFalse();
    }
  }
  return (
    <React.Fragment>
      <Button {...btnProps} onClick={isDialog.setTrue}>
        {props.children}
      </Button>
      <Drawer width={600} title={'请选择教案'} visible={isDialog.value} onClose={isDialog.setFalse}>
        <CourseArticleSelectedTable value={value} onChange={setValue} />
        <Button type={'primary'} loading={loading.value} onClick={onSelect} disabled={value.length === 0}>
          确定选择 {value.length} 项
        </Button>
      </Drawer>
    </React.Fragment>
  );
}

export default function CourseArticleSelectedTable(props: ICourseArticleSelectedTableProps) {
  const listState = useOpenApiFpRequest(CourseArticleApi, CourseArticleApi.prototype.courseArticleSearchGet);
  const keyword = useInput('');
  function refresh() {
    listState.requestSync({pi: 1, ps: 9999});
  }
  useEffect(() => {
    refresh();
  }, []);

  const displayRows = listState.data?.list?.filter(i => CourseArticleKeywordFilter(i, keyword.value));
  return (
    <div>
      <SearchAndRefresh {...keyword.valueBind} refresh={refresh} loading={listState.loading} />
      <Table
        size={'small'}
        bordered
        className={'m-t-10'}
        dataSource={displayRows || []}
        rowKey={'id'}
        loading={listState.loading}
        rowSelection={{
          selectedRowKeys: props.value.map(i => i.id as number),
          onChange(_, rows) {
            props.onChange(rows);
          },
        }}>
        <Table.Column title={'编号'} dataIndex={'id'} />
        <Table.Column title={'教案名称'} dataIndex={'topic'} />
      </Table>
    </div>
  );
}
